// removed by extract-text-webpack-plugin
module.exports = {"container":"_3sg6","banner":"_1eCo","text":"_2ZD6"};


//////////////////
// WEBPACK FOOTER
// ./src/components/homescreen/misssunrise/style.css
// module id = 397
// module chunks = 9